import getClientApiRequestTransformer from '@/api/transformers/auth.request.transformer';
import getSocketIdRequestTransformer from '@/api/transformers/socketId.request.transformer';
import axiosClient from '@/apiClient';
import axios, { AxiosResponse } from 'axios';

export default {
  fetchSocketEventsByLastSocketEventId(lastSocketEventId: number): Promise<any[]> {
    return axiosClient.get(`/event-log/list/${lastSocketEventId}`, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    })
      .then(({ data }: AxiosResponse<any[]>) => data);
  },
  fetchSocketEventsByLastSocketEventIdForTV(lastSocketEventId: number, placeId: string): Promise<any[]> {
    return axios.get(`/widget/event-log/list/${placeId}/${lastSocketEventId}`, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    })
      .then(({ data }: AxiosResponse<any[]>) => data);
  }
};
